import { FC } from 'react'
import { PatientUser } from '~/shared/types'
import { Provider } from '~/entities/provider'
import { useGetPerson } from '~/entities/person'
import { queueNotification } from '~/shared/notifications/actions'
import { useDispatch } from 'react-redux'
import PersonDetailLayout from './PersonDetailLayout'
import { usePersonToPatientRedirect } from './usePersonToPatientRedirect'

interface PersonDetailProps {
  personId: number
  providers: Provider[]
}

const PersonDetail: FC<PersonDetailProps> = props => {
  const { personId, providers } = props
  const { data: person, error: personFetchError } = useGetPerson({ personId })
  const patientUser: PatientUser = {} as PatientUser
  if (person) {
    patientUser.person = person
    // `PatientUser` types these as `string | undefined`; the generated Person
    // schema allows `null` for both. Coerce so the synthetic patient stays
    // assignable downstream.
    patientUser.first_name = person.first_name ?? undefined
    patientUser.last_name = person.last_name ?? undefined
  }

  const dispatch = useDispatch()

  // A signed-up member (person.user != null) is viewed as a patient; normalize the
  // URL (see the hook for why this must replace, not push).
  usePersonToPatientRedirect(person, personFetchError != null, () =>
    dispatch(queueNotification({ variant: 'error', message: 'Person does not exist' })),
  )

  return person ? (
    <PersonDetailLayout patient={patientUser} providers={providers} mode="person" person={person} />
  ) : null
}

export default PersonDetail
